import { Filtering, QDataTable, QEmptyState } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { LibraryTableFilters } from './Filter/LibraryTableFilters';
import { useLibraryTableColumns } from './hooks/useLibraryTableColumns';

export const LibraryV2Table = () => {
  const { t } = useTranslation();
  const columns = useLibraryTableColumns();

  return (
    <QDataTable data-cy="library-table" columns={columns}>
      <Filtering.FormContent>
        <LibraryTableFilters />
      </Filtering.FormContent>
      <QEmptyState
        title={t('emptyStates.noDocumentsFound')}
        subtitle={t('emptyStates.thereAreNoApprovedOrEffectiveDocuments')}
        data-cy="library-table-empty-state"
      />
    </QDataTable>
  );
};
